import React from "react";
import { Star } from "lucide-react";

/** Read-only rating: "4.1 ★ (40 ratings)", or "No ratings yet" when nobody has reviewed. */
export const StarRating = ({ average = 0, count = 0, size = 15, compact = false, testid = "star-rating" }) => {
  if (!count) {
    return <span className="text-sm text-muted-foreground" data-testid={`${testid}-empty`}>No ratings yet</span>;
  }
  return (
    <span className="inline-flex items-center gap-2" data-testid={testid}>
      <span className="inline-flex text-secondary">
        {[1, 2, 3, 4, 5].map((n) => (
          <Star key={n} size={size} className={n <= Math.round(average) ? "fill-current" : "opacity-30"} />
        ))}
      </span>
      {!compact && (
        <>
          <span className="text-sm font-medium" data-testid={`${testid}-value`}>{average.toFixed(1)}</span>
          <span className="text-sm text-muted-foreground" data-testid={`${testid}-count`}>
            ({count} {count === 1 ? "rating" : "ratings"})
          </span>
        </>
      )}
    </span>
  );
};

/** Clickable 1-5 stars for leaving a rating. */
export const StarPicker = ({ value = 0, onChange, size = 22, testid = "star-picker" }) => (
  <div className="flex gap-1" data-testid={testid}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" onClick={() => onChange(n)} aria-label={`${n} star`} data-testid={`${testid}-${n}`}>
        <Star size={size} className={n <= value ? "fill-current text-secondary" : "text-muted-foreground/40"} />
      </button>
    ))}
  </div>
);

export default StarRating;
